import { Box, Typography, useTheme, TableRow, TableCell, Theme } from "@mui/material"
import CustomTable from "../investorOverview/common/customTable"
import { CategoryTableBody, tableHeaderData } from "../investorOverview/mutualFund/common/Table"
import { Order, SortingObj } from "../investorOverview/types"
import { useSelector } from "react-redux"
import { RootStateType } from "../../redux-store/reducers"
import { formatCurrency } from "../../utils/utilityFunctions"
import {CategoryMobileResponsiveBody} from "../investorOverview/mutualFund/OverView"

type CategoriesTableProps = {
    title: string
    tableData: any
    isLoading: boolean
    handleTableSorting: (orderBy: string, order: Order) => void
    sortingObj: SortingObj,
    setSortingObj: ({ order, orderBy }: SortingObj) => void
}


export default function CategoryWiseBreakup(props: CategoriesTableProps): JSX.Element {
    const { title, tableData, isLoading, handleTableSorting, sortingObj } = props;
    const { palette } = useTheme()
    return (
        <Box sx={{
            padding:{ xs:'25px 15px 25px 10px', sm:'25px 30px 45px 30px'},
            background: palette.common.white,
            borderRadius: '20px'
        }}>
            <Typography variant="h2" color={palette.text.primary} sx={{ fontSize: { xs: '15px'},ml:{xs:2,sm:0}}}>
                {title}
            </Typography>
            <Box mt={'20px'}>
                <CustomTable
                    loadingRowsNum={4}
                    isLoading={isLoading}
                    tableBody={
                        <CategoryTableBody
                            tableBodyData={tableData || []}
                            handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                        />
                    }
                    tableData={tableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeaderData={tableHeaderData}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px",
                        }
                    }}
                    handleSort={handleTableSorting}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        },
                    }}
                    tableDataCount={tableData?.length || 0}
                    isPaginationVisible={false}
                    manualResponsiveBody={true}
                    hideResponsiveHeader={true}
                    ManualResponsiveBodyComponent={
                        <CategoryMobileResponsiveBody
                            // selectedHeaderKey={sortingObj.orderBy}
                            data={tableData || []}
                        />
                    }
                />
            </Box>
        </Box>
    )
}

// Custom Mobile Responsive Body Component for Category Wise Breakup
// function MobileResponsiveBody({ selectedHeaderKey, data }: { selectedHeaderKey: string, data: any[] }): JSX.Element {
//     const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

//     function calculatePercentage(x: string | number, y: string | number): string {
//         x = Number(x);
//         y = Number(y);

//         if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
//             return "-";
//         }

//         return `${Math.floor((x / y) * 100)}%`;
//     }

//     const getFormattedValue = (item: any, key: string) => {
//         switch (key) {
//             case 'categoryName':
//                 return item?.categoryName ?? "-";
//             case 'investedValue':
//                 return item?.investedValue < 0 ?
//                     `- ${formatCurrency({ value: Math.abs(item?.investedValue), locale, currencyCode })}` :
//                     `${formatCurrency({ value: item?.investedValue, locale, currencyCode })}`;
//             case 'marketValue':
//                 return item?.marketValue < 0 ?
//                     `- ${formatCurrency({ value: Math.abs(item?.marketValue), locale, currencyCode })}` :
//                     `${formatCurrency({ value: item?.marketValue, locale, currencyCode })}`;
//             case 'unRelease': {
//                 const unRealisedGainLossPerc = calculatePercentage(item?.unRelease, item?.investedValue);
//                 return `${item.unRelease < 0 ? "-" : ""}${formatCurrency({
//                     value: Math.abs(item.unRelease),
//                     locale,
//                     currencyCode,
//                 })} (${unRealisedGainLossPerc})`;
//             }
//             case 'irr':
//                 return item?.irr ? `${(item?.irr).toFixed(2)}%` : "-";
//             default:
//                 return item?.[key] ?? "-";
//         }
//     };

//     return (
//         <>
//             {data.map((item: any, index: number) => (
//                 <TableRow key={index}>
//                     <TableCell align="left">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 '&:hover': {
//                                     color: theme.palette.primary[500],
//                                 },
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {item?.categoryName ?? "-"}
//                         </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {getFormattedValue(item, selectedHeaderKey)}
//                         </Typography>
//                     </TableCell>
//                 </TableRow>
//             ))}
//         </>
//     );
// }